"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shopbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 66",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shopbrand01` : '') + (description ? ` desc-shopbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shopbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shopbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.089 65.996H16.285a4.448 4.448 0 0 1-4.559-3.685l-6.35-44.318a4.33 4.33 0 0 1 1.266-3.3 4.3 4.3 0 0 1 3.297-1.248h57.496a4.297 4.297 0 0 1 3.296 1.248c.87.87 1.33 2.07 1.262 3.3l-6.349 44.318a4.448 4.448 0 0 1-4.556 3.685Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F26B1C"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.095 64.534H56.86a5.448 5.448 0 0 0 5.565-4.543l6.35-44.318.008-.087a5.327 5.327 0 0 0-1.555-4.063 5.297 5.297 0 0 0-4.031-1.54H5.758a5.3 5.3 0 0 0-4.031 1.54 5.33 5.33 0 0 0-1.558 4.062c.002.03.005.059.009.088L6.527 59.99l.005.03a5.448 5.448 0 0 0 5.563 4.513Zm-3.59-4.843-6.34-44.255a3.33 3.33 0 0 1 .974-2.497 3.3 3.3 0 0 1 2.59-.956h57.496a1.197 1.197 0 0 0 .061-.002c.94-.057 1.86.291 2.53.958a3.326 3.326 0 0 1 .972 2.496l-6.34 44.256a3.448 3.448 0 0 1-3.569 2.843H12.035a3.448 3.448 0 0 1-3.53-2.843Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.428.158c6.202.02 11.516 4.444 12.681 10.549l.188.982-1.965.375-.188-.982c-.986-5.167-5.48-8.906-10.718-8.924-5.21.025-9.685 3.732-10.69 8.868l-.192.981-1.962-.384.192-.981C22.96 4.574 28.25.185 34.42.158h.007Z"
  }))));
};
var _default = exports.default = shopbrand01;